import { render } from "./MyBreadCrumb.vue?vue&type=template&id=3c1e35a2&scoped=true&ts=true"
import script from "./MyBreadCrumb.vue?vue&type=script&lang=ts"
export * from "./MyBreadCrumb.vue?vue&type=script&lang=ts"

import "./MyBreadCrumb.vue?vue&type=style&index=0&id=3c1e35a2&lang=less&scoped=true"

import exportComponent from "D:\\code\\hyz-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1e35a2"]])

export default __exports__